export default "__VITE_ASSET__4XHjBzTf__"